/* src/components/SortableTableUpgrade/SortableTableUpgrade.svelte generated by Svelte v3.48.0 */
import {
	HtmlTagHydration,
	SvelteComponent,
	add_flush_callback,
	append_hydration,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	children,
	claim_component,
	claim_element,
	claim_html_tag,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert_hydration,
	listen,
	mount_component,
	noop,
	outro_and_destroy_block,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import gql from 'nanographql';
import { getGraphqlClient } from '../../helpers/svelte/utils';
import orderBy from 'lodash.orderby';
import getGrade9 from '../../helpers/svelte/utils/getGrade9';
import { onMount } from 'svelte';
import Icon from '../Icon/Icon.svelte';
import IconHeader from '../IconHeader/IconHeader.svelte';

import {
	formatRate,
	roundToMax2Decimals
} from '../../helpers/svelte/utils/formatters';

import Modal from '../Modal/Modal.svelte';
import OwnershipTree from '../OwnershipTree/OwnershipTree.svelte';
import Tooltip from '../Tooltip/Tooltip.svelte';
import FilterBar from './FilterBar.svelte';
import FilterIcon from './components/FilterIcon.svelte';
import DownloadIcon from './components/DownloadIcon.svelte';
import SortIcon from './components/SortIcon.svelte';
import SortIconDown from './components/SortIconDown.svelte';
import Dropdown from './components/Dropdown.svelte';
import ModalNew from '../ModalNew/ModalNew.svelte';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[61] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[64] = list[i];
	return child_ctx;
}

function get_each_context_2(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[64] = list[i];
	return child_ctx;
}

function get_each_context_3(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[69] = list[i];
	child_ctx[71] = i;
	return child_ctx;
}

function get_each_context_4(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[72] = list[i];
	return child_ctx;
}

function get_each_context_5(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[72] = list[i];
	return child_ctx;
}

function get_each_context_6(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[72] = list[i];
	child_ctx[71] = i;
	return child_ctx;
}

// (482:2) {#if tableID}
function create_if_block_22(ctx) {
	let button0;
	let t0;
	let t1;
	let button1;
	let t2;
	let mounted;
	let dispose;

	return {
		c() {
			button0 = element("button");
			t0 = text("Back");
			t1 = space();
			button1 = element("button");
			t2 = text("Next");
			this.h();
		},
		l(nodes) {
			button0 = claim_element(nodes, "BUTTON", { class: true });
			var button0_nodes = children(button0);
			t0 = claim_text(button0_nodes, "Back");
			button0_nodes.forEach(detach);
			t1 = claim_space(nodes);
			button1 = claim_element(nodes, "BUTTON", { class: true });
			var button1_nodes = children(button1);
			t2 = claim_text(button1_nodes, "Next");
			button1_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button0, "class", "table-scroll-btn table-scroll-btn--left svelte-1lei7j1");
			attr(button1, "class", "table-scroll-btn table-scroll-btn--right svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, button0, anchor);
			append_hydration(button0, t0);
			insert_hydration(target, t1, anchor);
			insert_hydration(target, button1, anchor);
			append_hydration(button1, t2);

			if (!mounted) {
				dispose = [
					listen(button0, "click", /*click_handler*/ ctx[36]),
					listen(button1, "click", /*click_handler_1*/ ctx[37])
				];

				mounted = true;
			}
		},
		p: noop,
		d(detaching) {
			if (detaching) detach(button0);
			if (detaching) detach(t1);
			if (detaching) detach(button1);
			mounted = false;
			run_all(dispose);
		}
	};
}

// (493:14) {#if column.icon}
function create_if_block_21(ctx) {
	let span;
	let t;
	let icon;
	let current;
	icon = new Icon({ props: { icon: /*column*/ ctx[72].icon } });

	return {
		c() {
			span = element("span");
			t = space();
			create_component(icon.$$.fragment);
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", {});
			children(span).forEach(detach);
			t = claim_space(nodes);
			claim_component(icon.$$.fragment, nodes);
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			insert_hydration(target, t, anchor);
			mount_component(icon, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty[0] & /*columns*/ 1) icon_changes.icon = /*column*/ ctx[72].icon;
			icon.$set(icon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span);
			if (detaching) detach(t);
			destroy_component(icon, detaching);
		}
	};
}

// (498:14) {#if column.ServiceTypeToolTip}
function create_if_block_20(ctx) {
	let tooltip;
	let current;

	tooltip = new Tooltip({
			props: {
				text: "<div style='text-align:left'><strong>Electricity Only</strong> - This service type only accounts for the cost of electricity from the provider. Customers are likely charged an additional fee for the actual delivery of the electricity to their address. <br><br> <strong>Delivery Only</strong> - This service type only accounts for the delivery of the electricity. Customers are likely charged an additional fee for the actual cost of the electricity that they use. <br><br> <strong>Bundled</strong> - In some markets, the cost of electricity and the fees for the delivery of that electricity are charged separately. Bundled service types, however, have both of these charges built into a single price.</div>"
			}
		});

	return {
		c() {
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(tooltip, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(tooltip, detaching);
		}
	};
}

// (503:14) {#if column.tooltip}
function create_if_block_19(ctx) {
	let icon;
	let t;
	let tooltip;
	let current;
	icon = new Icon({ props: { icon: /*column*/ ctx[72].icon } });

	tooltip = new Tooltip({
			props: {
				text: "<div style='text-align:left'> " + /*column*/ ctx[72].tooltip + "</div>"
			}
		});

	return {
		c() {
			create_component(icon.$$.fragment);
			t = space();
			create_component(tooltip.$$.fragment);
		},
		l(nodes) {
			claim_component(icon.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(tooltip.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			insert_hydration(target, t, anchor);
			mount_component(tooltip, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const icon_changes = {};
			if (dirty[0] & /*columns*/ 1) icon_changes.icon = /*column*/ ctx[72].icon;
			icon.$set(icon_changes);
			const tooltip_changes = {};
			if (dirty[0] & /*columns*/ 1) tooltip_changes.text = "<div style='text-align:left'> " + /*column*/ ctx[72].tooltip + "</div>";
			tooltip.$set(tooltip_changes);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			transition_in(tooltip.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			transition_out(tooltip.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
			if (detaching) detach(t);
			destroy_component(tooltip, detaching);
		}
	};
}

// (508:16) {#if column.filterable}
function create_if_block_18(ctx) {
	let span0;
	let t;
	let span1;
	let filtericon;
	let current;

	function func_1(...args) {
		return /*func_1*/ ctx[38](/*i*/ ctx[71], ...args);
	}

	filtericon = new FilterIcon({
			props: {
				current: /*current*/ ctx[14][/*i*/ ctx[71]] === true,
				handleClick: func_1
			}
		});

	return {
		c() {
			span0 = element("span");
			t = space();
			span1 = element("span");
			create_component(filtericon.$$.fragment);
			this.h();
		},
		l(nodes) {
			span0 = claim_element(nodes, "SPAN", { style: true });
			var span0_nodes = children(span0);
			span0_nodes.forEach(detach);
			t = claim_space(nodes);
			span1 = claim_element(nodes, "SPAN", { style: true });
			var span1_nodes = children(span1);
			claim_component(filtericon.$$.fragment, span1_nodes);
			span1_nodes.forEach(detach);
			this.h();
		},
		h() {
			set_style(span0, "display", "inline-flex");
			set_style(span1, "pointer-events", "all");
			set_style(span1, "cursor", "pointer");
		},
		m(target, anchor) {
			insert_hydration(target, span0, anchor);
			insert_hydration(target, t, anchor);
			insert_hydration(target, span1, anchor);
			mount_component(filtericon, span1, null);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const filtericon_changes = {};
			if (dirty[0] & /*current, columns*/ 16385) filtericon_changes.current = /*current*/ ctx[14][/*i*/ ctx[71]] === true;
			if (dirty[0] & /*columns*/ 1) filtericon_changes.handleClick = func_1;
			filtericon.$set(filtericon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(filtericon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(filtericon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(span0);
			if (detaching) detach(t);
			if (detaching) detach(span1);
			destroy_component(filtericon);
		}
	};
}

// (524:16) {:else}
function create_else_block_5(ctx) {
	let sorticon;
	let current;

	function func_4() {
		return /*func_4*/ ctx[41](/*column*/ ctx[72]);
	}

	sorticon = new SortIcon({
			props: { handleClick: func_4, desc: true }
		});

	return {
		c() {
			create_component(sorticon.$$.fragment);
		},
		l(nodes) {
			claim_component(sorticon.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(sorticon, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const sorticon_changes = {};
			if (dirty[0] & /*columns*/ 1) sorticon_changes.handleClick = func_4;
			sorticon.$set(sorticon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sorticon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sorticon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sorticon, detaching);
		}
	};
}

// (517:16) {#if sortBy === column.property}
function create_if_block_16(ctx) {
	let current_block_type_index;
	let if_block;
	let if_block_anchor;
	let current;
	const if_block_creators = [create_if_block_17, create_else_block_4];
	const if_blocks = [];

	function select_block_type_1(ctx, dirty) {
		if (/*desc*/ ctx[2]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type_1(ctx, [-1, -1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_blocks[current_block_type_index].m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_1(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(if_block_anchor.parentNode, if_block_anchor);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if_blocks[current_block_type_index].d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (521:18) {:else}
function create_else_block_4(ctx) {
	let sorticon;
	let current;

	function func_3() {
		return /*func_3*/ ctx[40](/*column*/ ctx[72]);
	}

	sorticon = new SortIcon({
			props: {
				handleClick: func_3,
				desc: /*desc*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(sorticon.$$.fragment);
		},
		l(nodes) {
			claim_component(sorticon.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(sorticon, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const sorticon_changes = {};
			if (dirty[0] & /*columns*/ 1) sorticon_changes.handleClick = func_3;
			if (dirty[0] & /*desc*/ 4) sorticon_changes.desc = /*desc*/ ctx[2];
			sorticon.$set(sorticon_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sorticon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sorticon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sorticon, detaching);
		}
	};
}

// (519:18) {#if desc}
function create_if_block_17(ctx) {
	let sorticondown;
	let current;

	function func_2() {
		return /*func_2*/ ctx[39](/*column*/ ctx[72]);
	}

	sorticondown = new SortIconDown({
			props: {
				handleClick: func_2,
				desc: /*desc*/ ctx[2]
			}
		});

	return {
		c() {
			create_component(sorticondown.$$.fragment);
		},
		l(nodes) {
			claim_component(sorticondown.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(sorticondown, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const sorticondown_changes = {};
			if (dirty[0] & /*columns*/ 1) sorticondown_changes.handleClick = func_2;
			if (dirty[0] & /*desc*/ 4) sorticondown_changes.desc = /*desc*/ ctx[2];
			sorticondown.$set(sorticondown_changes);
		},
		i(local) {
			if (current) return;
			transition_in(sorticondown.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(sorticondown.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(sorticondown, detaching);
		}
	};
}

// (531:14) <ModalNew bind:active open={i === active} current={current[i] === true}>
function create_default_slot_1(ctx) {
	let filterbar;
	let current;

	function func_5(...args) {
		return /*func_5*/ ctx[42](/*column*/ ctx[72], ...args);
	}

	filterbar = new FilterBar({
			props: {
				activeKeyword: /*filters*/ ctx[9].filter(func_5),
				filterOn: /*column*/ ctx[72].property,
				title: /*column*/ ctx[72].label
			}
		});

	filterbar.$on("cancel", /*handleCancel*/ ctx[31]);
	filterbar.$on("apply", /*handleApply*/ ctx[29]);
	filterbar.$on("closeModal", /*handleCancel*/ ctx[31]);

	return {
		c() {
			create_component(filterbar.$$.fragment);
		},
		l(nodes) {
			claim_component(filterbar.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(filterbar, target, anchor);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			const filterbar_changes = {};
			if (dirty[0] & /*filters, columns*/ 513) filterbar_changes.activeKeyword = /*filters*/ ctx[9].filter(func_5);
			if (dirty[0] & /*columns*/ 1) filterbar_changes.filterOn = /*column*/ ctx[72].property;
			if (dirty[0] & /*columns*/ 1) filterbar_changes.title = /*column*/ ctx[72].label;
			filterbar.$set(filterbar_changes);
		},
		i(local) {
			if (current) return;
			transition_in(filterbar.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(filterbar.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(filterbar, detaching);
		}
	};
}

// (490:10) {#each columns.filter((c) => c.active) as column, i (column.label)}
function create_each_block_6(key_1, ctx) {
	let th;
	let span0;
	let t0_value = /*column*/ ctx[72].label + "";
	let t0;
	let t1;
	let t2;
	let t3;
	let t4;
	let span1;
	let t5;
	let current_block_type_index;
	let if_block4;
	let t6;
	let modalnew;
	let updating_active;
	let t7;
	let current;
	let if_block0 = /*column*/ ctx[72].icon && create_if_block_21(ctx);
	let if_block1 = /*column*/ ctx[72].ServiceTypeToolTip && create_if_block_20(ctx);
	let if_block2 = /*column*/ ctx[72].tooltip && create_if_block_19(ctx);
	let if_block3 = /*column*/ ctx[72].filterable && create_if_block_18(ctx);
	const if_block_creators = [create_if_block_16, create_else_block_5];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*sortBy*/ ctx[1] === /*column*/ ctx[72].property) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, [-1, -1, -1]);
	if_block4 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	function modalnew_active_binding(value) {
		/*modalnew_active_binding*/ ctx[43](value);
	}

	let modalnew_props = {
		open: /*i*/ ctx[71] === /*active*/ ctx[13],
		current: /*current*/ ctx[14][/*i*/ ctx[71]] === true,
		$$slots: { default: [create_default_slot_1] },
		$$scope: { ctx }
	};

	if (/*active*/ ctx[13] !== void 0) {
		modalnew_props.active = /*active*/ ctx[13];
	}

	modalnew = new ModalNew({ props: modalnew_props });
	binding_callbacks.push(() => bind(modalnew, 'active', modalnew_active_binding));

	return {
		key: key_1,
		first: null,
		c() {
			th = element("th");
			span0 = element("span");
			t0 = text(t0_value);
			t1 = space();
			if (if_block0) if_block0.c();
			t2 = space();
			if (if_block1) if_block1.c();
			t3 = space();
			if (if_block2) if_block2.c();
			t4 = space();
			span1 = element("span");
			if (if_block3) if_block3.c();
			t5 = space();
			if_block4.c();
			t6 = space();
			create_component(modalnew.$$.fragment);
			t7 = space();
			this.h();
		},
		l(nodes) {
			th = claim_element(nodes, "TH", { tabindex: true, class: true });
			var th_nodes = children(th);
			span0 = claim_element(th_nodes, "SPAN", {});
			var span0_nodes = children(span0);
			t0 = claim_text(span0_nodes, t0_value);
			span0_nodes.forEach(detach);
			t1 = claim_space(th_nodes);
			if (if_block0) if_block0.l(th_nodes);
			t2 = claim_space(th_nodes);
			if (if_block1) if_block1.l(th_nodes);
			t3 = claim_space(th_nodes);
			if (if_block2) if_block2.l(th_nodes);
			t4 = claim_space(th_nodes);
			span1 = claim_element(th_nodes, "SPAN", {});
			var span1_nodes = children(span1);
			if (if_block3) if_block3.l(span1_nodes);
			t5 = claim_space(span1_nodes);
			if_block4.l(span1_nodes);
			span1_nodes.forEach(detach);
			t6 = claim_space(th_nodes);
			claim_component(modalnew.$$.fragment, th_nodes);
			t7 = claim_space(th_nodes);
			th_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(th, "tabindex", "0");
			attr(th, "class", "sorting svelte-1lei7j1");
			toggle_class(th, "secondary", /*column*/ ctx[72].secondary);
			toggle_class(th, "tertiary", /*column*/ ctx[72].tertiary);
			this.first = th;
		},
		m(target, anchor) {
			insert_hydration(target, th, anchor);
			append_hydration(th, span0);
			append_hydration(span0, t0);
			append_hydration(th, t1);
			if (if_block0) if_block0.m(th, null);
			append_hydration(th, t2);
			if (if_block1) if_block1.m(th, null);
			append_hydration(th, t3);
			if (if_block2) if_block2.m(th, null);
			append_hydration(th, t4);
			append_hydration(th, span1);
			if (if_block3) if_block3.m(span1, null);
			append_hydration(span1, t5);
			if_blocks[current_block_type_index].m(span1, null);
			append_hydration(th, t6);
			mount_component(modalnew, th, null);
			append_hydration(th, t7);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if ((!current || dirty[0] & /*columns*/ 1) && t0_value !== (t0_value = /*column*/ ctx[72].label + "")) set_data(t0, t0_value);

			if (/*column*/ ctx[72].icon) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*columns*/ 1) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_21(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(th, t2);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (/*column*/ ctx[72].ServiceTypeToolTip) {
				if (if_block1) {
					if (dirty[0] & /*columns*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_20(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(th, t3);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			if (/*column*/ ctx[72].tooltip) {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty[0] & /*columns*/ 1) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block_19(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(th, t4);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}

			if (/*column*/ ctx[72].filterable) {
				if (if_block3) {
					if_block3.p(ctx, dirty);

					if (dirty[0] & /*columns*/ 1) {
						transition_in(if_block3, 1);
					}
				} else {
					if_block3 = create_if_block_18(ctx);
					if_block3.c();
					transition_in(if_block3, 1);
					if_block3.m(span1, t5);
				}
			} else if (if_block3) {
				group_outros();

				transition_out(if_block3, 1, 1, () => {
					if_block3 = null;
				});

				check_outros();
			}

			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block4 = if_blocks[current_block_type_index];

				if (!if_block4) {
					if_block4 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block4.c();
				} else {
					if_block4.p(ctx, dirty);
				}

				transition_in(if_block4, 1);
				if_block4.m(span1, null);
			}

			const modalnew_changes = {};
			if (dirty[0] & /*columns, active*/ 8193) modalnew_changes.open = /*i*/ ctx[71] === /*active*/ ctx[13];
			if (dirty[0] & /*current, columns*/ 16385) modalnew_changes.current = /*current*/ ctx[14][/*i*/ ctx[71]] === true;

			if (dirty[0] & /*filters, columns*/ 513 | dirty[2] & /*$$scope*/ 65536) {
				modalnew_changes.$$scope = { dirty, ctx };
			}

			if (!updating_active && dirty[0] & /*active*/ 8192) {
				updating_active = true;
				modalnew_changes.active = /*active*/ ctx[13];
				add_flush_callback(() => updating_active = false);
			}

			modalnew.$set(modalnew_changes);

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(th, "secondary", /*column*/ ctx[72].secondary);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(th, "tertiary", /*column*/ ctx[72].tertiary);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			transition_in(if_block2);
			transition_in(if_block3);
			transition_in(if_block4);
			transition_in(modalnew.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			transition_out(if_block2);
			transition_out(if_block3);
			transition_out(if_block4);
			transition_out(modalnew.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(th);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if_blocks[current_block_type_index].d();
			destroy_component(modalnew);
		}
	};
}

// (547:10) {#if serverPaginate}
function create_if_block_12(ctx) {
	let tr;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let current;
	let each_value_5 = /*columns*/ ctx[0].filter(func_6);
	const get_key = ctx => /*column*/ ctx[72].label;

	for (let i = 0; i < each_value_5.length; i += 1) {
		let child_ctx = get_each_context_5(ctx, each_value_5, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_5(key, child_ctx));
	}

	return {
		c() {
			tr = element("tr");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			tr = claim_element(nodes, "TR", { class: true });
			var tr_nodes = children(tr);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(tr_nodes);
			}

			tr_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(tr, "class", "svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, tr, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(tr, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty[0] & /*columns, sortedItems, currentPlantName, ownershipItems, currentProvider, currentProviderRelations, getOwnershipData, toggleModal, FORMATTERS*/ 321355777) {
				each_value_5 = /*columns*/ ctx[0].filter(func_6);
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_5, each_1_lookup, tr, outro_and_destroy_block, create_each_block_5, null, get_each_context_5);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_5.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(tr);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}
		}
	};
}

// (571:18) {:else}
function create_else_block_3(ctx) {
	let t_value = /*item*/ ctx[69][/*column*/ ctx[72].property] + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		l(nodes) {
			t = claim_text(nodes, t_value);
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*sortedItems, columns*/ 2097153 && t_value !== (t_value = /*item*/ ctx[69][/*column*/ ctx[72].property] + "")) set_data(t, t_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (557:45) 
function create_if_block_14(ctx) {
	let html_tag;
	let raw_value = /*FORMATTERS*/ ctx[25][/*column*/ ctx[72].formatter](/*item*/ ctx[69][/*column*/ ctx[72].property], /*item*/ ctx[69]) + "";
	let t;
	let if_block_anchor;
	let if_block = /*column*/ ctx[72].formatter === 'plantName' && create_if_block_15(ctx);

	return {
		c() {
			html_tag = new HtmlTagHydration(false);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			html_tag = claim_html_tag(nodes, false);
			t = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			html_tag.a = t;
		},
		m(target, anchor) {
			html_tag.m(raw_value, target, anchor);
			insert_hydration(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*columns, sortedItems*/ 2097153 && raw_value !== (raw_value = /*FORMATTERS*/ ctx[25][/*column*/ ctx[72].formatter](/*item*/ ctx[69][/*column*/ ctx[72].property], /*item*/ ctx[69]) + "")) html_tag.p(raw_value);

			if (/*column*/ ctx[72].formatter === 'plantName') {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_15(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) html_tag.d();
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (555:18) {#if !item[column.property]}
function create_if_block_13(ctx) {
	let icon;
	let current;
	icon = new Icon({ props: { icon: "nil" } });

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		l(nodes) {
			claim_component(icon.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (559:20) {#if column.formatter === 'plantName'}
function create_if_block_15(ctx) {
	let span;
	let mounted;
	let dispose;

	function click_handler_2() {
		return /*click_handler_2*/ ctx[44](/*item*/ ctx[69]);
	}

	return {
		c() {
			span = element("span");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			children(span).forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "owner-info");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);

			if (!mounted) {
				dispose = listen(span, "click", click_handler_2);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

// (549:14) {#each columns.filter((c) => c.active) as column (column.label)}
function create_each_block_5(key_1, ctx) {
	let td;
	let current_block_type_index;
	let if_block;
	let t;
	let current;
	const if_block_creators = [create_if_block_13, create_if_block_14, create_else_block_3];
	const if_blocks = [];

	function select_block_type_2(ctx, dirty) {
		if (!/*item*/ ctx[69][/*column*/ ctx[72].property]) return 0;
		if (/*column*/ ctx[72].formatter) return 1;
		return 2;
	}

	current_block_type_index = select_block_type_2(ctx, [-1, -1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		key: key_1,
		first: null,
		c() {
			td = element("td");
			if_block.c();
			t = space();
			this.h();
		},
		l(nodes) {
			td = claim_element(nodes, "TD", { class: true });
			var td_nodes = children(td);
			if_block.l(td_nodes);
			t = claim_space(td_nodes);
			td_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(td, "class", "svelte-1lei7j1");
			toggle_class(td, "secondary", /*column*/ ctx[72].secondary);
			toggle_class(td, "tertiary", /*column*/ ctx[72].tertiary);
			toggle_class(td, "price", /*column*/ ctx[72].formatter === 'price');
			this.first = td;
		},
		m(target, anchor) {
			insert_hydration(target, td, anchor);
			if_blocks[current_block_type_index].m(td, null);
			append_hydration(td, t);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_2(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(td, t);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "secondary", /*column*/ ctx[72].secondary);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "tertiary", /*column*/ ctx[72].tertiary);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "price", /*column*/ ctx[72].formatter === 'price');
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(td);
			if_blocks[current_block_type_index].d();
		}
	};
}

// (576:10) {#if !serverPaginate && i + 1 > pageSize * (page - 1) && i + 1 <= pageSize * page}
function create_if_block_8(ctx) {
	let tr;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let t;
	let current;
	let each_value_4 = /*columns*/ ctx[0].filter(func_7);
	const get_key = ctx => /*column*/ ctx[72].label;

	for (let i = 0; i < each_value_4.length; i += 1) {
		let child_ctx = get_each_context_4(ctx, each_value_4, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block_4(key, child_ctx));
	}

	return {
		c() {
			tr = element("tr");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t = space();
			this.h();
		},
		l(nodes) {
			tr = claim_element(nodes, "TR", { class: true });
			var tr_nodes = children(tr);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(tr_nodes);
			}

			t = claim_space(tr_nodes);
			tr_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(tr, "class", "svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, tr, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(tr, null);
			}

			append_hydration(tr, t);
			current = true;
		},
		p(ctx, dirty) {
			if (dirty[0] & /*columns, sortedItems, currentPlantName, ownershipItems, currentProvider, currentProviderRelations, getOwnershipData, toggleModal, FORMATTERS*/ 321355777) {
				each_value_4 = /*columns*/ ctx[0].filter(func_7);
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_4, each_1_lookup, tr, outro_and_destroy_block, create_each_block_4, t, get_each_context_4);
				check_outros();
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value_4.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(tr);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}
		}
	};
}

// (600:18) {:else}
function create_else_block_2(ctx) {
	let t_value = /*item*/ ctx[69][/*column*/ ctx[72].property] + "";
	let t;

	return {
		c() {
			t = text(t_value);
		},
		l(nodes) {
			t = claim_text(nodes, t_value);
		},
		m(target, anchor) {
			insert_hydration(target, t, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*sortedItems, columns*/ 2097153 && t_value !== (t_value = /*item*/ ctx[69][/*column*/ ctx[72].property] + "")) set_data(t, t_value);
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(t);
		}
	};
}

// (586:45) 
function create_if_block_10(ctx) {
	let html_tag;
	let raw_value = /*FORMATTERS*/ ctx[25][/*column*/ ctx[72].formatter](/*item*/ ctx[69][/*column*/ ctx[72].property], /*item*/ ctx[69]) + "";
	let t;
	let if_block_anchor;
	let if_block = /*column*/ ctx[72].formatter === 'plantName' && create_if_block_11(ctx);

	return {
		c() {
			html_tag = new HtmlTagHydration(false);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
			this.h();
		},
		l(nodes) {
			html_tag = claim_html_tag(nodes, false);
			t = claim_space(nodes);
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
			this.h();
		},
		h() {
			html_tag.a = t;
		},
		m(target, anchor) {
			html_tag.m(raw_value, target, anchor);
			insert_hydration(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*columns, sortedItems*/ 2097153 && raw_value !== (raw_value = /*FORMATTERS*/ ctx[25][/*column*/ ctx[72].formatter](/*item*/ ctx[69][/*column*/ ctx[72].property], /*item*/ ctx[69]) + "")) html_tag.p(raw_value);

			if (/*column*/ ctx[72].formatter === 'plantName') {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_11(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) html_tag.d();
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (584:18) {#if !item[column.property]}
function create_if_block_9(ctx) {
	let icon;
	let current;
	icon = new Icon({ props: { icon: "nil" } });

	return {
		c() {
			create_component(icon.$$.fragment);
		},
		l(nodes) {
			claim_component(icon.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(icon, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(icon, detaching);
		}
	};
}

// (588:20) {#if column.formatter === 'plantName'}
function create_if_block_11(ctx) {
	let span;
	let mounted;
	let dispose;

	function click_handler_3() {
		return /*click_handler_3*/ ctx[45](/*item*/ ctx[69]);
	}

	return {
		c() {
			span = element("span");
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			children(span).forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "owner-info");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);

			if (!mounted) {
				dispose = listen(span, "click", click_handler_3);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
		},
		d(detaching) {
			if (detaching) detach(span);
			mounted = false;
			dispose();
		}
	};
}

// (578:14) {#each columns.filter((c) => c.active) as column (column.label)}
function create_each_block_4(key_1, ctx) {
	let td;
	let current_block_type_index;
	let if_block;
	let current;
	const if_block_creators = [create_if_block_9, create_if_block_10, create_else_block_2];
	const if_blocks = [];

	function select_block_type_3(ctx, dirty) {
		if (!/*item*/ ctx[69][/*column*/ ctx[72].property]) return 0;
		if (/*column*/ ctx[72].formatter) return 1;
		return 2;
	}

	current_block_type_index = select_block_type_3(ctx, [-1, -1, -1]);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		key: key_1,
		first: null,
		c() {
			td = element("td");
			if_block.c();
			this.h();
		},
		l(nodes) {
			td = claim_element(nodes, "TD", { class: true });
			var td_nodes = children(td);
			if_block.l(td_nodes);
			td_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(td, "class", "svelte-1lei7j1");
			toggle_class(td, "secondary", /*column*/ ctx[72].secondary);
			toggle_class(td, "tertiary", /*column*/ ctx[72].tertiary);
			toggle_class(td, "price", /*column*/ ctx[72].formatter === 'price');
			this.first = td;
		},
		m(target, anchor) {
			insert_hydration(target, td, anchor);
			if_blocks[current_block_type_index].m(td, null);
			current = true;
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type_3(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(td, null);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "secondary", /*column*/ ctx[72].secondary);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "tertiary", /*column*/ ctx[72].tertiary);
			}

			if (dirty[0] & /*columns*/ 1) {
				toggle_class(td, "price", /*column*/ ctx[72].formatter === 'price');
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(td);
			if_blocks[current_block_type_index].d();
		}
	};
}

// (546:8) {#each sortedItems as item, i}
function create_each_block_3(ctx) {
	let t;
	let if_block1_anchor;
	let current;
	let if_block0 = /*serverPaginate*/ ctx[8] && create_if_block_12(ctx);
	let if_block1 = !/*serverPaginate*/ ctx[8] && /*i*/ ctx[71] + 1 > /*pageSize*/ ctx[4] * (/*page*/ ctx[3] - 1) && /*i*/ ctx[71] + 1 <= /*pageSize*/ ctx[4] * /*page*/ ctx[3] && create_if_block_8(ctx);

	return {
		c() {
			if (if_block0) if_block0.c();
			t = space();
			if (if_block1) if_block1.c();
			if_block1_anchor = empty();
		},
		l(nodes) {
			if (if_block0) if_block0.l(nodes);
			t = claim_space(nodes);
			if (if_block1) if_block1.l(nodes);
			if_block1_anchor = empty();
		},
		m(target, anchor) {
			if (if_block0) if_block0.m(target, anchor);
			insert_hydration(target, t, anchor);
			if (if_block1) if_block1.m(target, anchor);
			insert_hydration(target, if_block1_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			if (/*serverPaginate*/ ctx[8]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty[0] & /*serverPaginate*/ 256) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_12(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(t.parentNode, t);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			if (!/*serverPaginate*/ ctx[8] && /*i*/ ctx[71] + 1 > /*pageSize*/ ctx[4] * (/*page*/ ctx[3] - 1) && /*i*/ ctx[71] + 1 <= /*pageSize*/ ctx[4] * /*page*/ ctx[3]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);

					if (dirty[0] & /*serverPaginate, pageSize, page*/ 280) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_8(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block0);
			transition_in(if_block1);
			current = true;
		},
		o(local) {
			transition_out(if_block0);
			transition_out(if_block1);
			current = false;
		},
		d(detaching) {
			if (if_block0) if_block0.d(detaching);
			if (detaching) detach(t);
			if (if_block1) if_block1.d(detaching);
			if (detaching) detach(if_block1_anchor);
		}
	};
}

// (611:4) {#if serverPaginate && pageCount > 1}
function create_if_block_5(ctx) {
	let nav;
	let ul;
	let each_value_2 = /*pages*/ ctx[10];
	let each_blocks = [];

	for (let i = 0; i < each_value_2.length; i += 1) {
		each_blocks[i] = create_each_block_2(get_each_context_2(ctx, each_value_2, i));
	}

	return {
		c() {
			nav = element("nav");
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { "aria-label": true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(ul, "class", "pagination svelte-1lei7j1");
			attr(nav, "aria-label", "Navigate table");
		},
		m(target, anchor) {
			insert_hydration(target, nav, anchor);
			append_hydration(nav, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*pages, page, fetchFilteredPage, filters*/ 8390152) {
				each_value_2 = /*pages*/ ctx[10];
				let i;

				for (i = 0; i < each_value_2.length; i += 1) {
					const child_ctx = get_each_context_2(ctx, each_value_2, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_2(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_2.length;
			}
		},
		d(detaching) {
			if (detaching) detach(nav);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (615:12) {#if p > page - 5 && p < page + 5}
function create_if_block_6(ctx) {
	let if_block_anchor;

	function select_block_type_4(ctx, dirty) {
		if (/*p*/ ctx[64] === /*page*/ ctx[3]) return create_if_block_7;
		return create_else_block_1;
	}

	let current_block_type = select_block_type_4(ctx, [-1, -1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_4(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (620:14) {:else}
function create_else_block_1(ctx) {
	let li;
	let button;
	let t0_value = /*p*/ ctx[64] + "";
	let t0;
	let t1;
	let mounted;
	let dispose;

	function click_handler_4() {
		return /*click_handler_4*/ ctx[46](/*p*/ ctx[64]);
	}

	return {
		c() {
			li = element("li");
			button = element("button");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			button = claim_element(li_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t0 = claim_text(button_nodes, t0_value);
			button_nodes.forEach(detach);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "page-link svelte-1lei7j1");
			attr(li, "class", "page-item svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, button);
			append_hydration(button, t0);
			append_hydration(li, t1);

			if (!mounted) {
				dispose = listen(button, "click", click_handler_4);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[0] & /*pages*/ 1024 && t0_value !== (t0_value = /*p*/ ctx[64] + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			dispose();
		}
	};
}

// (616:14) {#if p === page}
function create_if_block_7(ctx) {
	let li;
	let span;
	let t0_value = /*p*/ ctx[64] + "";
	let t0;
	let t1;

	return {
		c() {
			li = element("li");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true, "aria-current": true });
			var li_nodes = children(li);
			span = claim_element(li_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			span_nodes.forEach(detach);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "page-link svelte-1lei7j1");
			attr(li, "class", "page-item active svelte-1lei7j1");
			attr(li, "aria-current", "page");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, span);
			append_hydration(span, t0);
			append_hydration(li, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*pages*/ 1024 && t0_value !== (t0_value = /*p*/ ctx[64] + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (614:10) {#each pages as p}
function create_each_block_2(ctx) {
	let if_block_anchor;
	let if_block = /*p*/ ctx[64] > /*page*/ ctx[3] - 5 && /*p*/ ctx[64] < /*page*/ ctx[3] + 5 && create_if_block_6(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (/*p*/ ctx[64] > /*page*/ ctx[3] - 5 && /*p*/ ctx[64] < /*page*/ ctx[3] + 5) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_6(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (637:4) {#if !serverPaginate && paginate && pageCount > 1}
function create_if_block_2(ctx) {
	let nav;
	let ul;
	let each_value_1 = /*pages*/ ctx[10];
	let each_blocks = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	return {
		c() {
			nav = element("nav");
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			nav = claim_element(nodes, "NAV", { "aria-label": true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(ul, "class", "pagination svelte-1lei7j1");
			attr(nav, "aria-label", "Navigate table");
		},
		m(target, anchor) {
			insert_hydration(target, nav, anchor);
			append_hydration(nav, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}
		},
		p(ctx, dirty) {
			if (dirty[0] & /*pages, page*/ 1032) {
				each_value_1 = /*pages*/ ctx[10];
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block_1(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value_1.length;
			}
		},
		d(detaching) {
			if (detaching) detach(nav);
			destroy_each(each_blocks, detaching);
		}
	};
}

// (641:12) {#if p > page - 5 && p < page + 5}
function create_if_block_3(ctx) {
	let if_block_anchor;

	function select_block_type_5(ctx, dirty) {
		if (/*p*/ ctx[64] === /*page*/ ctx[3]) return create_if_block_4;
		return create_else_block;
	}

	let current_block_type = select_block_type_5(ctx, [-1, -1, -1]);
	let if_block = current_block_type(ctx);

	return {
		c() {
			if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (current_block_type === (current_block_type = select_block_type_5(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			}
		},
		d(detaching) {
			if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (646:14) {:else}
function create_else_block(ctx) {
	let li;
	let button;
	let t_value = /*p*/ ctx[64] + "";
	let t;
	let mounted;
	let dispose;

	function click_handler_5() {
		return /*click_handler_5*/ ctx[47](/*p*/ ctx[64]);
	}

	return {
		c() {
			li = element("li");
			button = element("button");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			button = claim_element(li_nodes, "BUTTON", { class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, t_value);
			button_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "class", "page-link svelte-1lei7j1");
			attr(li, "class", "page-item svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, button);
			append_hydration(button, t);

			if (!mounted) {
				dispose = listen(button, "click", click_handler_5);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[0] & /*pages*/ 1024 && t_value !== (t_value = /*p*/ ctx[64] + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			dispose();
		}
	};
}

// (642:14) {#if p === page}
function create_if_block_4(ctx) {
	let li;
	let span;
	let t0_value = /*p*/ ctx[64] + "";
	let t0;
	let t1;

	return {
		c() {
			li = element("li");
			span = element("span");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true, "aria-current": true });
			var li_nodes = children(li);
			span = claim_element(li_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t0 = claim_text(span_nodes, t0_value);
			span_nodes.forEach(detach);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "page-link svelte-1lei7j1");
			attr(li, "class", "page-item active svelte-1lei7j1");
			attr(li, "aria-current", "page");
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, span);
			append_hydration(span, t0);
			append_hydration(li, t1);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*pages*/ 1024 && t0_value !== (t0_value = /*p*/ ctx[64] + "")) set_data(t0, t0_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (640:10) {#each pages as p}
function create_each_block_1(ctx) {
	let if_block_anchor;
	let if_block = /*p*/ ctx[64] > /*page*/ ctx[3] - 5 && /*p*/ ctx[64] < /*page*/ ctx[3] + 5 && create_if_block_3(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		l(nodes) {
			if (if_block) if_block.l(nodes);
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert_hydration(target, if_block_anchor, anchor);
		},
		p(ctx, dirty) {
			if (/*p*/ ctx[64] > /*page*/ ctx[3] - 5 && /*p*/ ctx[64] < /*page*/ ctx[3] + 5) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block_3(ctx);
					if_block.c();
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (655:4) {#if tfootData}
function create_if_block_1(ctx) {
	let span;

	let t_value = (/*searchMode*/ ctx[20]
	? /*totalCount*/ ctx[11]
	: /*tfootData*/ ctx[6]) + "";

	let t;

	return {
		c() {
			span = element("span");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			span = claim_element(nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t = claim_text(span_nodes, t_value);
			span_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "table-footer__data svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, span, anchor);
			append_hydration(span, t);
		},
		p(ctx, dirty) {
			if (dirty[0] & /*searchMode, totalCount, tfootData*/ 1050688 && t_value !== (t_value = (/*searchMode*/ ctx[20]
			? /*totalCount*/ ctx[11]
			: /*tfootData*/ ctx[6]) + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

// (663:0) {#if showModal}
function create_if_block(ctx) {
	let modal;
	let current;

	modal = new Modal({
			props: {
				width: "1200px",
				title: /*currentPlantName*/ ctx[18],
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	modal.$on("modal-close", /*modal_close_handler*/ ctx[49]);

	return {
		c() {
			create_component(modal.$$.fragment);
		},
		l(nodes) {
			claim_component(modal.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(modal, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const modal_changes = {};
			if (dirty[0] & /*currentPlantName*/ 262144) modal_changes.title = /*currentPlantName*/ ctx[18];

			if (dirty[0] & /*ownershipItems, currentProvider, currentProviderRelations*/ 229376 | dirty[2] & /*$$scope*/ 65536) {
				modal_changes.$$scope = { dirty, ctx };
			}

			modal.$set(modal_changes);
		},
		i(local) {
			if (current) return;
			transition_in(modal.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(modal.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(modal, detaching);
		}
	};
}

// (678:10) {#each ownershipItems as owner}
function create_each_block(ctx) {
	let li;
	let div;
	let t0_value = /*owner*/ ctx[61].provider_name + "";
	let t0;
	let t1;
	let mounted;
	let dispose;

	function click_handler_6() {
		return /*click_handler_6*/ ctx[48](/*owner*/ ctx[61]);
	}

	return {
		c() {
			li = element("li");
			div = element("div");
			t0 = text(t0_value);
			t1 = space();
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			div = claim_element(li_nodes, "DIV", { class: true });
			var div_nodes = children(div);
			t0 = claim_text(div_nodes, t0_value);
			div_nodes.forEach(detach);
			t1 = claim_space(li_nodes);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(div, "class", "page-link svelte-1lei7j1");
			attr(li, "class", "page-item svelte-1lei7j1");
			toggle_class(li, "active", /*currentProvider*/ ctx[16].provider_id === /*owner*/ ctx[61].provider_id);
		},
		m(target, anchor) {
			insert_hydration(target, li, anchor);
			append_hydration(li, div);
			append_hydration(div, t0);
			append_hydration(li, t1);

			if (!mounted) {
				dispose = listen(li, "click", click_handler_6);
				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			if (dirty[0] & /*ownershipItems*/ 32768 && t0_value !== (t0_value = /*owner*/ ctx[61].provider_name + "")) set_data(t0, t0_value);

			if (dirty[0] & /*currentProvider, ownershipItems*/ 98304) {
				toggle_class(li, "active", /*currentProvider*/ ctx[16].provider_id === /*owner*/ ctx[61].provider_id);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			mounted = false;
			dispose();
		}
	};
}

// (664:2) <Modal width="1200px" title={currentPlantName} on:modal-close={() => (showModal = false)}>
function create_default_slot(ctx) {
	let div;
	let ownershiptree;
	let t;
	let nav;
	let ul;
	let current;

	ownershiptree = new OwnershipTree({
			props: {
				providerRelationships: /*currentProviderRelations*/ ctx[17],
				provider: /*currentProvider*/ ctx[16]
			}
		});

	let each_value = /*ownershipItems*/ ctx[15];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			div = element("div");
			create_component(ownershiptree.$$.fragment);
			t = space();
			nav = element("nav");
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			claim_component(ownershiptree.$$.fragment, div_nodes);
			t = claim_space(div_nodes);
			nav = claim_element(div_nodes, "NAV", { "aria-label": true });
			var nav_nodes = children(nav);
			ul = claim_element(nav_nodes, "UL", { class: true });
			var ul_nodes = children(ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul_nodes);
			}

			ul_nodes.forEach(detach);
			nav_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(ul, "class", "pagination svelte-1lei7j1");
			attr(nav, "aria-label", "Page navigation example");
			attr(div, "class", "modal-body");
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			mount_component(ownershiptree, div, null);
			append_hydration(div, t);
			append_hydration(div, nav);
			append_hydration(nav, ul);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			const ownershiptree_changes = {};
			if (dirty[0] & /*currentProviderRelations*/ 131072) ownershiptree_changes.providerRelationships = /*currentProviderRelations*/ ctx[17];
			if (dirty[0] & /*currentProvider*/ 65536) ownershiptree_changes.provider = /*currentProvider*/ ctx[16];
			ownershiptree.$set(ownershiptree_changes);

			if (dirty[0] & /*currentProvider, ownershipItems, currentProviderRelations, getOwnershipData*/ 17006592) {
				each_value = /*ownershipItems*/ ctx[15];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i(local) {
			if (current) return;
			transition_in(ownershiptree.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(ownershiptree.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(ownershiptree);
			destroy_each(each_blocks, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div3;
	let div0;
	let dropdown;
	let updating_items;
	let t0;
	let t1;
	let div1;
	let table;
	let thead;
	let tr;
	let each_blocks_1 = [];
	let each0_lookup = new Map();
	let t2;
	let tbody;
	let t3;
	let div2;
	let t4;
	let t5;
	let t6;
	let if_block4_anchor;
	let current;
	let mounted;
	let dispose;

	function dropdown_items_binding(value) {
		/*dropdown_items_binding*/ ctx[35](value);
	}

	let dropdown_props = {};

	if (/*columns*/ ctx[0] !== void 0) {
		dropdown_props.items = /*columns*/ ctx[0];
	}

	dropdown = new Dropdown({ props: dropdown_props });
	binding_callbacks.push(() => bind(dropdown, 'items', dropdown_items_binding));
	let if_block0 = /*tableID*/ ctx[7] && create_if_block_22(ctx);
	let each_value_6 = /*columns*/ ctx[0].filter(func);
	const get_key = ctx => /*column*/ ctx[72].label;

	for (let i = 0; i < each_value_6.length; i += 1) {
		let child_ctx = get_each_context_6(ctx, each_value_6, i);
		let key = get_key(child_ctx);
		each0_lookup.set(key, each_blocks_1[i] = create_each_block_6(key, child_ctx));
	}

	let each_value_3 = /*sortedItems*/ ctx[21];
	let each_blocks = [];

	for (let i = 0; i < each_value_3.length; i += 1) {
		each_blocks[i] = create_each_block_3(get_each_context_3(ctx, each_value_3, i));
	}

	const out = i => transition_out(each_blocks[i], 1, 1, () => {
		each_blocks[i] = null;
	});

	let if_block1 = /*serverPaginate*/ ctx[8] && /*pageCount*/ ctx[12] > 1 && create_if_block_5(ctx);
	let if_block2 = !/*serverPaginate*/ ctx[8] && /*paginate*/ ctx[5] && /*pageCount*/ ctx[12] > 1 && create_if_block_2(ctx);
	let if_block3 = /*tfootData*/ ctx[6] && create_if_block_1(ctx);
	let if_block4 = /*showModal*/ ctx[19] && create_if_block(ctx);

	return {
		c() {
			div3 = element("div");
			div0 = element("div");
			create_component(dropdown.$$.fragment);
			t0 = space();
			if (if_block0) if_block0.c();
			t1 = space();
			div1 = element("div");
			table = element("table");
			thead = element("thead");
			tr = element("tr");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			t2 = space();
			tbody = element("tbody");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t3 = space();
			div2 = element("div");
			if (if_block1) if_block1.c();
			t4 = space();
			if (if_block2) if_block2.c();
			t5 = space();
			if (if_block3) if_block3.c();
			t6 = space();
			if (if_block4) if_block4.c();
			if_block4_anchor = empty();
			this.h();
		},
		l(nodes) {
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			div0 = claim_element(div3_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			claim_component(dropdown.$$.fragment, div0_nodes);
			div0_nodes.forEach(detach);
			t0 = claim_space(div3_nodes);
			if (if_block0) if_block0.l(div3_nodes);
			t1 = claim_space(div3_nodes);
			div1 = claim_element(div3_nodes, "DIV", { id: true, class: true });
			var div1_nodes = children(div1);
			table = claim_element(div1_nodes, "TABLE", { class: true });
			var table_nodes = children(table);
			thead = claim_element(table_nodes, "THEAD", {});
			var thead_nodes = children(thead);
			tr = claim_element(thead_nodes, "TR", { class: true });
			var tr_nodes = children(tr);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(tr_nodes);
			}

			tr_nodes.forEach(detach);
			thead_nodes.forEach(detach);
			t2 = claim_space(table_nodes);
			tbody = claim_element(table_nodes, "TBODY", {});
			var tbody_nodes = children(tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(tbody_nodes);
			}

			tbody_nodes.forEach(detach);
			table_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			t3 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			if (if_block1) if_block1.l(div2_nodes);
			t4 = claim_space(div2_nodes);
			if (if_block2) if_block2.l(div2_nodes);
			t5 = claim_space(div2_nodes);
			if (if_block3) if_block3.l(div2_nodes);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t6 = claim_space(nodes);
			if (if_block4) if_block4.l(nodes);
			if_block4_anchor = empty();
			this.h();
		},
		h() {
			attr(div0, "class", "add-remove-container svelte-1lei7j1");
			attr(tr, "class", "svelte-1lei7j1");
			attr(table, "class", "table sortable-table svelte-1lei7j1");
			attr(div1, "id", /*tableID*/ ctx[7]);
			attr(div1, "class", "table-responsive");
			attr(div2, "class", "table-footer svelte-1lei7j1");
			attr(div3, "class", "table-wrapper svelte-1lei7j1");
		},
		m(target, anchor) {
			insert_hydration(target, div3, anchor);
			append_hydration(div3, div0);
			mount_component(dropdown, div0, null);
			append_hydration(div3, t0);
			if (if_block0) if_block0.m(div3, null);
			append_hydration(div3, t1);
			append_hydration(div3, div1);
			append_hydration(div1, table);
			append_hydration(table, thead);
			append_hydration(thead, tr);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(tr, null);
			}

			append_hydration(table, t2);
			append_hydration(table, tbody);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(tbody, null);
			}

			append_hydration(div3, t3);
			append_hydration(div3, div2);
			if (if_block1) if_block1.m(div2, null);
			append_hydration(div2, t4);
			if (if_block2) if_block2.m(div2, null);
			append_hydration(div2, t5);
			if (if_block3) if_block3.m(div2, null);
			insert_hydration(target, t6, anchor);
			if (if_block4) if_block4.m(target, anchor);
			insert_hydration(target, if_block4_anchor, anchor);
			current = true;

			if (!mounted) {
				dispose = listen(div1, "scroll", /*toggleScrollButtons*/ ctx[27]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			const dropdown_changes = {};

			if (!updating_items && dirty[0] & /*columns*/ 1) {
				updating_items = true;
				dropdown_changes.items = /*columns*/ ctx[0];
				add_flush_callback(() => updating_items = false);
			}

			dropdown.$set(dropdown_changes);

			if (/*tableID*/ ctx[7]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_22(ctx);
					if_block0.c();
					if_block0.m(div3, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty[0] & /*columns, active, current, filters, handleApply, handleSort, desc, sortBy, handleFilterClick*/ 1614832135 | dirty[1] & /*handleCancel*/ 1) {
				each_value_6 = /*columns*/ ctx[0].filter(func);
				group_outros();
				each_blocks_1 = update_keyed_each(each_blocks_1, dirty, get_key, 1, ctx, each_value_6, each0_lookup, tr, outro_and_destroy_block, create_each_block_6, null, get_each_context_6);
				check_outros();
			}

			if (dirty[0] & /*columns, sortedItems, currentPlantName, ownershipItems, currentProvider, currentProviderRelations, getOwnershipData, toggleModal, FORMATTERS, serverPaginate, pageSize, page*/ 321356057) {
				each_value_3 = /*sortedItems*/ ctx[21];
				let i;

				for (i = 0; i < each_value_3.length; i += 1) {
					const child_ctx = get_each_context_3(ctx, each_value_3, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
						transition_in(each_blocks[i], 1);
					} else {
						each_blocks[i] = create_each_block_3(child_ctx);
						each_blocks[i].c();
						transition_in(each_blocks[i], 1);
						each_blocks[i].m(tbody, null);
					}
				}

				group_outros();

				for (i = each_value_3.length; i < each_blocks.length; i += 1) {
					out(i);
				}

				check_outros();
			}

			if (!current || dirty[0] & /*tableID*/ 128) {
				attr(div1, "id", /*tableID*/ ctx[7]);
			}

			if (/*serverPaginate*/ ctx[8] && /*pageCount*/ ctx[12] > 1) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block_5(ctx);
					if_block1.c();
					if_block1.m(div2, t4);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (!/*serverPaginate*/ ctx[8] && /*paginate*/ ctx[5] && /*pageCount*/ ctx[12] > 1) {
				if (if_block2) {
					if_block2.p(ctx, dirty);
				} else {
					if_block2 = create_if_block_2(ctx);
					if_block2.c();
					if_block2.m(div2, t5);
				}
			} else if (if_block2) {
				if_block2.d(1);
				if_block2 = null;
			}

			if (/*tfootData*/ ctx[6]) {
				if (if_block3) {
					if_block3.p(ctx, dirty);
				} else {
					if_block3 = create_if_block_1(ctx);
					if_block3.c();
					if_block3.m(div2, null);
				}
			} else if (if_block3) {
				if_block3.d(1);
				if_block3 = null;
			}

			if (/*showModal*/ ctx[19]) {
				if (if_block4) {
					if_block4.p(ctx, dirty);

					if (dirty[0] & /*showModal*/ 524288) {
						transition_in(if_block4, 1);
					}
				} else {
					if_block4 = create_if_block(ctx);
					if_block4.c();
					transition_in(if_block4, 1);
					if_block4.m(if_block4_anchor.parentNode, if_block4_anchor);
				}
			} else if (if_block4) {
				group_outros();

				transition_out(if_block4, 1, 1, () => {
					if_block4 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(dropdown.$$.fragment, local);

			for (let i = 0; i < each_value_6.length; i += 1) {
				transition_in(each_blocks_1[i]);
			}

			for (let i = 0; i < each_value_3.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			transition_in(if_block4);
			current = true;
		},
		o(local) {
			transition_out(dropdown.$$.fragment, local);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				transition_out(each_blocks_1[i]);
			}

			each_blocks = each_blocks.filter(Boolean);

			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			transition_out(if_block4);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			destroy_component(dropdown);
			if (if_block0) if_block0.d();

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].d();
			}

			destroy_each(each_blocks, detaching);
			if (if_block1) if_block1.d();
			if (if_block2) if_block2.d();
			if (if_block3) if_block3.d();
			if (detaching) detach(t6);
			if (if_block4) if_block4.d(detaching);
			if (detaching) detach(if_block4_anchor);
			mounted = false;
			dispose();
		}
	};
}

let scrollTableSpeed = 120;
let scrollButtonSize = 28;
const func = c => c.active;
const func_6 = c => c.active;
const func_7 = c => c.active;

function instance($$self, $$props, $$invalidate) {
	let pageCount;
	let castAsText;
	let sortedItems;
	let { items } = $$props;
	let { columns } = $$props;
	let { sortBy } = $$props;
	let { pageSize = 20 } = $$props;
	let { paginate = true } = $$props;
	let { page = 1 } = $$props;
	let { desc = false } = $$props;
	let { tfootData } = $$props;
	let { tableID } = $$props;
	let { serverPaginate = false } = $$props;
	let { totalItems } = $$props;
	let { tableName } = $$props;
	const isDev = process.env.componentType === 'browser' && window && window.location.hostname.includes('localhost');

	// with server paginate, it's set at 20 page size
	// Items relevant for filtering functionality
	let active = null;

	let current = Array.from({ length: 3 });
	let { filters = [] } = $$props;
	let useModal;
	let egKey = '';

	onMount(() => {
		const egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	let pages;

	const goodValues = isAscending => value => {
		if (typeof value[sortBy] !== 'string' && isNaN(value[sortBy])) {
			return isAscending ? Infinity : -Infinity;
		}

		return value[sortBy] || '';
	};

	function sort() {
		$$invalidate(21, sortedItems = orderBy(items, [goodValues(!desc), sortBy], [desc ? 'desc' : 'asc']));
	}

	async function handleSort(sortField) {
		if (sortBy === sortField) {
			$$invalidate(2, desc = !desc);
		} else {
			$$invalidate(2, desc = false);
			$$invalidate(1, sortBy = sortField);
		}

		if (serverPaginate) {
			fetchFilteredPage(filters);
		}
	}

	const baseApiUrl = process.env.HOST;
	let totalCount;

	async function fetchFilteredPage(filters) {
		// create queryParams from one or more filters
		const optionalQueryParams = {};

		filters.forEach((filter, index) => {
			if (filter.filterOn && filter.keyword) {
				optionalQueryParams[`filteron${index + 1}`] = filter.filterOn;
				optionalQueryParams[`keyword${index + 1}`] = filter.keyword;
			}
		});

		const queryParams = {
			offset: (page - 1) * 20,
			sortby: sortBy,
			desc,
			castastext: castAsText,
			...optionalQueryParams
		};

		// Construct the query string
		const queryString = new URLSearchParams(queryParams).toString();

		// Construct the full API URL
		const apiUrl = `${baseApiUrl}/api/paginate/${tableName}?${queryString}`;

		try {
			const results = await fetch(apiUrl, {
				method: 'GET',
				headers: { 'eg-key': egKey }
			});

			const data = await results.json();
			$$invalidate(21, sortedItems = data.data);
			$$invalidate(11, totalCount = +data.count[0].count);
		} catch(e) {
			console.log(e);
		}
	}

	// function handleKeydown({ key }, sortField) {
	//   console.log('handlekeydown');
	//   if (key === 'Enter') {
	//     handleSort(sortField);
	//   }
	// }
	const formatLink = url => new URL(url).host; // avoid long visible links

	let ownershipItems = [];
	let currentProvider = {};
	let currentProviderRelations = [];
	let currentPlantName = '';
	const graphql = getGraphqlClient();

	const getProviderOwnership = gql`
    query providerOwnershipById($id: Int!) {
      __typename
      result: allProviderGroupingsForPlantOwnerships(condition: { initialProviderId: $id }, orderBy: DEPTH_DESC) {
        nodes {
          initialProviderId
          initialProviderName
          initialProviderSlug
          sourceProviderId
          sourceProviderName
          sourceProviderSlug
          targetProviderId
          targetProviderName
          targetProviderSlug
          relationshipType
          percentSourceOwnedByTarget
          depth
        }
      }
    }
  `;

	async function getOwnershipData(provider) {
		const r = await graphql(getProviderOwnership({ id: provider.provider_id }), { 'eg-key': egKey });

		if (r.errors) {
			errors = r.errors;
			console.log(r.errors);
		}

		if (r.data && r.data.result && r.data.result.nodes) {
			return r.data.result.nodes;
		}
	}

	// custom formatters (functions) cannot be passed as props because of JSON.stringify during partial hydration
	const FORMATTERS = {
		fuelTypes: (value, item) => value.join('<br/>'),
		plantNames: (value, item) => `<div class="column">${item.plant_names.join('<hr style="margin:0;"/>')}</div>`,
		plantName: (value, item) => `<div class="column"><span>${value}</span>${item.owners
		? item.owners.reduce(
				(sum, current) => {
					if (current.provider_id && current.provider_name && current.provider_name !== '$') {
						return sum += current.provider_active
						? `<a href="${current.permalink}">${current.provider_name} (${Number(parseFloat(current.fraction_owned) * 100).toFixed(2)}%)</a>`
						: `<span class="owner">${current.provider_name} (${Number(parseFloat(current.fraction_owned) * 100).toFixed(2)}%)</span>`;
					} else if (current.provider_eiaid && current.provider_eiaid !== '$') {
						return sum += `${current.provider_eiaid} (${Number(parseFloat(current.fraction_owned) * 100).toFixed(2)}%)`;
					}

					return sum;
				},
				''
			)
		: 'No owners in our system'}</div>`,
		plantNameSimple: (value, item) => `<div class="column"><span>${value}</span></div>`,
		countyLink: (value, item) => `<a href="${item.permalink}">${item.name}</a>`,
		stateLink: (value, item) => `<a href="${item.permalink}">${item.name}</a>`,
		providerLink: (value, item) => `<a href="${item.permalink}">${value}</a>`,
		providerConditionalLink: (value, item) => {
			if (item.permalink) {
				return `<a href="${item.permalink}">${value}</a>`;
			} else {
				return `<div>${value}</div>`;
			}
		},
		providers: value => {
			if (Array.isArray(value)) return value.length;
			return value;
		},
		url: value => value
		? `<a href=${value} target="_blank" rel="nofollow noopener">${formatLink(value)}</a>`
		: '',
		providerCoverageUrl: value => value
		? `<a href=${value} >findenergy.com${value}</a>`
		: '',
		string: value => value,
		number: value => Number(Number(value).toFixed(2)).toLocaleString(),
		revenues: value => Number((1000 * value).toFixed(2)).toLocaleString(),
		rate: value => `${Number(value * 100).toFixed(2)}`,
		hideNull: value => value || '',
		grade: value => `<div class="align-center"><div class="rating-grade">${getGrade9(value)}</div></div>`,
		yesno: value => `${value ? '<span class="color-red">Yes</span>' : 'No'}`,
		kgmwh: value => Number(value) >= 0
		? `${Number(value).toFixed(1)}<span class="unit">kg/MWh</span>`
		: 'N/A',
		time_period: value => value === 0
		? ''
		: value % 100 === 0
			? `${value / 100}`
			: `${value % 100}/${Math.floor(value / 100)}`,
		price_bill: value => `$${Number(value).toFixed(2)}/mo`,
		price_kwh: value => `${formatRate(value)}`,
		percentage: value => `${roundToMax2Decimals(value * 100)}%`,
		mwh: (value, item) => {
			// &#8593; up
			// &#8595; down
			if (item.production_fraction_change === null || typeof item.production_fraction_change === 'undefined' || //item.production_fraction_change === 1 ||
			item.production_fraction_change === 0) {
				return `${Number(value.toFixed(0)).toLocaleString()}<span class="unit test">MWh</span>`;
			} else if (item.production_fraction_change > 0 && typeof item.production_previous_period !== 'undefined' && item.production_previous_period !== null) {
				if (value < 0) {
					return `<span title="Negative electricity production is a result of the power plant importing more electricity from the grid than what it exported to the grid. This is common in power plants that are used only during peak demand time periods as a way to supplement unmet demand. Additionally, this could be the result of a power plant that is down for extensive maintenance but must still use electricity during the downtime.">${Number(value.toFixed(0)).toLocaleString()}</span><span class="unit">MWh</span><span class="text-danger" title="${Number(item.production_fraction_change * 100).toFixed(2)}%  decrease compared to the prior year's value of ${Number(item.production_previous_period.toFixed(1)).toLocaleString()}MWh.">&#8595;</span>`;
				} else {
					return `${Number(value.toFixed(0)).toLocaleString()}<span class="unit">MWh</span> <span class="text-success" title="${Number(Number(item.production_fraction_change * 100).toFixed(2)).toLocaleString()}% increase over the prior year's value of ${Number(item.production_previous_period.toFixed(1)).toLocaleString()}MWh.">&#8593;</span>`;
				}
			} else if (item.production_fraction_change < 0 && typeof item.production_previous_period !== 'undefined' && item.production_previous_period !== null) {
				if (value < 0) {
					return `<span title="Negative electricity production is a result of the power plant importing more electricity from the grid than what it exported to the grid. This is common in power plants that are used only during peak demand time periods as a way to supplement unmet demand. Additionally, this could be the result of a power plant that is down for extensive maintenance but must still use electricity during the downtime.">${Number(value.toFixed(0)).toLocaleString()}</span><span class="unit">MWh</span><span class="text-danger" title="${Number(item.production_fraction_change * 100).toFixed(2)}%  decrease compared to the prior year's value of ${Number(item.production_previous_period.toFixed(1)).toLocaleString()}MWh.">&#8595;</span>`;
				} else {
					return `${Number(value.toFixed(0)).toLocaleString()}<span class="unit">MWh</span><span class="text-danger" title="${Number(item.production_fraction_change * 100).toFixed(2)}%  decrease compared to the prior year's value of ${Number(item.production_previous_period.toFixed(1)).toLocaleString()}MWh.">&#8595;</span>`;
				}
			}
		},
		kg: (value, item) => {
			// &#8593; up
			// &#8595; down
			let isNegative = false;

			if (value < 0) {
				isNegative = true;
			}

			if (item.emission_fraction_change === null || typeof item.emission_fraction_change === 'undefined' || //item.emission_fraction_change === 1 ||
			item.emission_fraction_change === 0) {
				return `${Number(Number(value).toFixed(1)).toLocaleString()}<span class="unit">kg</span>`;
			} else if (item.emission_fraction_change > 0 && typeof item.emission_previous_period !== 'undefined' && item.emission_previous_period !== null) {
				return `${Number(Number(value).toFixed(1)).toLocaleString()}<span class="unit">kg</span> <span class="text-success" title="${Number(item.emission_fraction_change * 100).toFixed(2)}% increase over the prior year's value of ${Number(item.emission_previous_period.toFixed(1)).toLocaleString()}kg">&#8593;</span>`;
			} else if (item.emission_fraction_change < 0 && typeof item.emission_previous_period !== 'undefined' && item.emission_previous_period !== null) {
				return `${Number(Number(value).toFixed(1)).toLocaleString()}<span class="unit">kg</span> <span class="text-danger" title="${Number(item.emission_fraction_change * 100).toFixed(2)}%  decrease compared to the prior year's value of ${Number(item.emission_previous_period.toFixed(1)).toLocaleString()}kg">&#8595;</span>`;
			}
		}
	};

	// SCROLL BUTTONS: Position buttons on page scroll
	onMount(() => {
		if (tableID) {
			const table = document.getElementById(tableID);
			const tableParent = table.parentNode;

			let tableScrollButtonLeft = tableParent.querySelector('.table-scroll-btn--left'),
				tableScrollButtonRight = tableParent.querySelector('.table-scroll-btn--right'),
				tableScrollRight = table.scrollWidth - (table.scrollLeft + table.clientWidth);

			if (tableScrollRight > 0) {
				tableScrollButtonRight.style.right = `0px`;
			}

			window.addEventListener('scroll', () => {
				let tableOffsetTop = table.getBoundingClientRect().top,
					tableOffsetBottom = table.getBoundingClientRect().bottom;

				if (tableOffsetTop < 100 && tableOffsetBottom > 250) {
					tableScrollButtonLeft.style.top = `${Math.round(Math.abs(tableOffsetTop)) + 100}px`;
					tableScrollButtonRight.style.top = `${Math.round(Math.abs(tableOffsetTop)) + 100}px`;
				}
			});
		}
	});

	// SCROLL BUTTONS: Scroll on Click
	const scrollTable = scrollPosition => {
		const table = document.getElementById(tableID);

		if (scrollPosition === 'right') {
			table.scrollLeft += scrollTableSpeed;
		}

		if (scrollPosition === 'left') {
			table.scrollLeft -= scrollTableSpeed;
		}
	};

	// SCROLL BUTTONS: Toggle Buttons on scroll
	const toggleScrollButtons = () => {
		if (tableID) {
			const table = document.getElementById(tableID);
			const tableParent = table.parentNode;

			let tableScrollButtonLeft = tableParent.querySelector('.table-scroll-btn--left'),
				tableScrollButtonRight = tableParent.querySelector('.table-scroll-btn--right'),
				tableScrollRight = table.scrollWidth - (table.scrollLeft + table.clientWidth);

			if (tableScrollRight <= 0) {
				tableScrollButtonRight.style.right = `-${scrollButtonSize}px`;
			} else {
				tableScrollButtonRight.style.right = '0';
			}

			if (table.scrollLeft <= 0) {
				tableScrollButtonLeft.style.left = `-${scrollButtonSize}px`;
			} else {
				tableScrollButtonLeft.style.left = '0';
			}
		}
	};

	// Modal
	let showModal = false;

	const toggleModal = () => {
		$$invalidate(19, showModal = !showModal);
	};

	const updateFilters = (filters, newFilter) => {
		const tableNames = filters.map(filter => filter.filterOn);

		if (tableNames.includes(newFilter.filterOn)) {
			filters.forEach(filter => {
				if (filter.filterOn === newFilter.filterOn) {
					filter.keyword = newFilter.keyword;
				}
			});
		} else {
			filters.push(newFilter);
		}
	};

	let searchMode = false;

	const handleApply = async e => {
		// reset page to 1 when a new filter is applied
		$$invalidate(3, page = 1);

		if (e.detail.keyword.length < 1) {
			$$invalidate(14, current[active] = false, current);
		} else {
			$$invalidate(14, current[active] = true, current);
		}

		$$invalidate(13, active = null);

		updateFilters(filters, {
			filterOn: e.detail.filterOn,
			keyword: e.detail.keyword
		});

		await fetchFilteredPage(filters);

		const combinedKeyword = filters.map(filter => filter.keyword).filter(keyword => keyword).join(', '); // Extract the keyword from each object
		// Filter out empty keywords

		if (combinedKeyword.length > 0) {
			$$invalidate(20, searchMode = true);
		} else {
			$$invalidate(20, searchMode = false);
		}
	}; // console.log('search keyword:', e.detail.keyword);

	const handleFilterClick = (event, i) => {
		event.stopPropagation();

		if (active !== i) {
			$$invalidate(13, active = i);
		} else {
			$$invalidate(13, active = null);
		}
	};

	const handleCancel = () => {
		$$invalidate(13, active = null);
	};

	function dropdown_items_binding(value) {
		columns = value;
		$$invalidate(0, columns);
	}

	const click_handler = () => scrollTable('left');
	const click_handler_1 = () => scrollTable('right');
	const func_1 = (i, e) => handleFilterClick(e, i);
	const func_2 = column => handleSort(column.property);
	const func_3 = column => handleSort(column.property);
	const func_4 = column => handleSort(column.property);
	const func_5 = (column, d) => d.filterOn === column.property;

	function modalnew_active_binding(value) {
		active = value;
		$$invalidate(13, active);
	}

	const click_handler_2 = async item => {
		$$invalidate(18, currentPlantName = item.name || item.plant_name);
		$$invalidate(15, ownershipItems = item.owners);
		$$invalidate(16, currentProvider = ownershipItems[0]);
		$$invalidate(17, currentProviderRelations = await getOwnershipData(ownershipItems[0]));
		toggleModal();
	};

	const click_handler_3 = async item => {
		$$invalidate(18, currentPlantName = item.name || item.plant_name);
		$$invalidate(15, ownershipItems = item.owners);
		$$invalidate(16, currentProvider = ownershipItems[0]);
		$$invalidate(17, currentProviderRelations = await getOwnershipData(ownershipItems[0]));
		toggleModal();
	};

	const click_handler_4 = async p => {
		$$invalidate(3, page = p);
		await fetchFilteredPage(filters);
	};

	const click_handler_5 = p => $$invalidate(3, page = p);

	const click_handler_6 = async owner => {
		$$invalidate(16, currentProvider = owner);
		$$invalidate(17, currentProviderRelations = await getOwnershipData(owner));
	};

	const modal_close_handler = () => $$invalidate(19, showModal = false);

	$$self.$$set = $$props => {
		if ('items' in $$props) $$invalidate(32, items = $$props.items);
		if ('columns' in $$props) $$invalidate(0, columns = $$props.columns);
		if ('sortBy' in $$props) $$invalidate(1, sortBy = $$props.sortBy);
		if ('pageSize' in $$props) $$invalidate(4, pageSize = $$props.pageSize);
		if ('paginate' in $$props) $$invalidate(5, paginate = $$props.paginate);
		if ('page' in $$props) $$invalidate(3, page = $$props.page);
		if ('desc' in $$props) $$invalidate(2, desc = $$props.desc);
		if ('tfootData' in $$props) $$invalidate(6, tfootData = $$props.tfootData);
		if ('tableID' in $$props) $$invalidate(7, tableID = $$props.tableID);
		if ('serverPaginate' in $$props) $$invalidate(8, serverPaginate = $$props.serverPaginate);
		if ('totalItems' in $$props) $$invalidate(33, totalItems = $$props.totalItems);
		if ('tableName' in $$props) $$invalidate(34, tableName = $$props.tableName);
		if ('filters' in $$props) $$invalidate(9, filters = $$props.filters);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty[0] & /*serverPaginate, pageSize*/ 272 | $$self.$$.dirty[1] & /*totalItems, items*/ 6) {
			$: $$invalidate(12, pageCount = serverPaginate
			? Math.ceil(totalItems / 20)
			: Math.ceil(items.length / pageSize));
		}

		if ($$self.$$.dirty[0] & /*columns*/ 1) {
			// If there are any columns that are not searchable by 'WHERE ILIKE' cast them as text
			$: castAsText = columns.reduce(
				(acc, item) => {
					if (item.CastAsText) {
						acc.push(item.property);
					}

					return acc;
				},
				[]
			);
		}

		if ($$self.$$.dirty[0] & /*pageCount, totalCount, pages*/ 7168) {
			$: if (pageCount && !totalCount) {
				let pi = 1;
				$$invalidate(10, pages = []);

				while (pages.length < pageCount) {
					pages.push(pi);
					pi += 1;
				}
			} else if (totalCount) {
				let pi = 1;
				$$invalidate(10, pages = []);

				while (pages.length < Math.ceil(totalCount / 20)) {
					pages.push(pi);
					pi += 1;
				}
			}
		}

		if ($$self.$$.dirty[0] & /*serverPaginate, sortBy, desc*/ 262 | $$self.$$.dirty[1] & /*items*/ 2) {
			$: $$invalidate(21, sortedItems = serverPaginate
			? items
			: orderBy(items, [sortBy], [desc ? 'desc' : 'asc']));
		}

		if ($$self.$$.dirty[0] & /*serverPaginate, sortBy, desc*/ 262) {
			$: if (!serverPaginate) sort(sortBy, desc);
		}
	};

	return [
		columns,
		sortBy,
		desc,
		page,
		pageSize,
		paginate,
		tfootData,
		tableID,
		serverPaginate,
		filters,
		pages,
		totalCount,
		pageCount,
		active,
		current,
		ownershipItems,
		currentProvider,
		currentProviderRelations,
		currentPlantName,
		showModal,
		searchMode,
		sortedItems,
		handleSort,
		fetchFilteredPage,
		getOwnershipData,
		FORMATTERS,
		scrollTable,
		toggleScrollButtons,
		toggleModal,
		handleApply,
		handleFilterClick,
		handleCancel,
		items,
		totalItems,
		tableName,
		dropdown_items_binding,
		click_handler,
		click_handler_1,
		func_1,
		func_2,
		func_3,
		func_4,
		func_5,
		modalnew_active_binding,
		click_handler_2,
		click_handler_3,
		click_handler_4,
		click_handler_5,
		click_handler_6,
		modal_close_handler
	];
}

class SortableTableUpgrade extends SvelteComponent {
	constructor(options) {
		super();

		init(
			this,
			options,
			instance,
			create_fragment,
			safe_not_equal,
			{
				items: 32,
				columns: 0,
				sortBy: 1,
				pageSize: 4,
				paginate: 5,
				page: 3,
				desc: 2,
				tfootData: 6,
				tableID: 7,
				serverPaginate: 8,
				totalItems: 33,
				tableName: 34,
				filters: 9
			},
			null,
			[-1, -1, -1]
		);
	}
}

export default SortableTableUpgrade;